import { makeStyles } from '@material-ui/core';
import Colors from '../../../../../constants/Colors';
import { neutral } from '../../../../../shared/styles/colors';

export default makeStyles(() => ({
  container: {
    borderRadius: '0.5rem',
    border: `1px solid ${neutral[20]}`,
    margin: '0.5rem 0',
  },
  cardContainer: {
    background: neutral.white,
    color: neutral.D20,
  },
  titleContainer: {
    borderBottom: `1px solid ${neutral.D10}`,
  },
  title: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    fontSize: '1rem',
  },
  quantity: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: neutral[100],
    paddingRight: '1rem',
  },
  chipDisclaimer: {
    padding: '0.25rem 0.5rem',
  },
  chipText: {
    fontWeight: 500,
    fontFamily: 'PP Object Sans',
  },
  headerDivider: {
    borderRight: `1px solid ${neutral.D10}`,
  },
  replaceItem: {
    color: Colors.PRIMARY_COLOR,
  },
  deleteItem: {
    color: neutral.D18,
  },
  cardBody: {
    borderTop: `1px solid ${neutral.D10}`,
  },
  description: {
    paddingTop: '0.5rem',
    color: neutral[60],
    fontSize: '0.75rem',
    fontWeight: 400,
    fontFamily: 'PP Object Sans',
  },
  alertMessage: {
    margin: '1.25rem 0',
  },
  toppingCategory: {
    color: neutral[80],
    fontSize: '0.75rem',
  },
  toppingDescription: {
    fontSize: '0.875rem',
    width: '100%',
  },
  cardFooter: {
    padding: '1.25rem 1rem',
  },
  subtotal: {
    fontWeight: 600,
  },
  corridorName: {
    color: Colors.PRIMARY_COLOR,
    fontSize: '0.75rem',
    fontWeight: 600,
    marginTop: '1rem',
    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
}));
